








































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { DepositModel } from '@/models/deposit';
@Component
export default class TrackingProgress extends Vue {
    @Prop({default: null})
    private order!: DepositModel;
}
